import * as React from "react";
import type { SVGProps } from "react";
const SvgLiftDrag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#lift-drag_svg__a)">
      <path d="M12 22c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v16c0 .55-.45 1-1 1" />
      <path d="M15 22H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1M8 7c-.4 0-.79-.25-.94-.65-.19-.52.07-1.09.58-1.29l8.01-3c.52-.19 1.09.07 1.29.59.19.52-.07 1.09-.58 1.29l-8.01 3C8.23 6.98 8.12 7 8 7" />
    </g>
    <defs>
      <clipPath id="lift-drag_svg__a">
        <path fill="#fff" d="M7 2h10v20H7z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLiftDrag;
